<template>
  <div class="Container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
                :autoSearch="false"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
        <commonTable
          ref="tableCommon"
          :mode="tab"
          @handleManage="onManageBtnClicked"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
          :clueAction="clueAction"
        />
      </b-col>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "../components/commonTable.vue";
import SearchFilter from "../components/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      tabs: [{ title: "แจ้งเบาะแส", mode: "List" }],
      activeTab: ["List"],
      clueAction: "Search",
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    onManageBtnClicked(id) {
      // รับมาเป็น clueId
      const _this = this;
      const routeData = this.$router.resolve({
        // ใส่ clueId, clueAction ลงกระเป๋า query แล้วโยนออกไป
        name: "ClueSearchManage",
        query: {
          id: id,
          clueAction: _this.clueAction,
        },
      });
      window.open(routeData.href, "_blank");
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      if (this.activeTab[0] == "GroupProcess") {
        const routeData = this.$router.resolve({
          name: "ScreeningGroupManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        //(this.activeTab[0]=='List' || this.activeTab[0]=='Group')
        const routeData = this.$router.resolve({
          name: "ScreeningManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      params.mode = "search";
      console.log("route", this.$route);
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(this.$router.resolve({ name: "RoleManage" }).href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
